import * as yup from 'yup';
import { IPersonalDataStepGM } from './steps/PersonalDataStep';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ISummaryStepGM } from './steps/SummaryStep';
import { ICFFactorTypeOption } from '../factor-service';
import { phoneValidationRegExp } from '../bf-hooks';

export const usePersonalDataGMValidationSchema = (): yup.ObjectSchema<IPersonalDataStepGM> => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );

  const schema = React.useMemo( () => {
    const formValidationSchema = yup.object<IPersonalDataStepGM>( {
      gender: yup.string().required(),
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      birthDate: yup.string().required(),
      optInNewsletter: yup.boolean().notRequired(),
      zipCode: yup.lazy( ( val ) => {
        switch ( typeof val ) {
          case 'object':
            return yup.object<ICFFactorTypeOption>( {
              name: yup.string(),
              key: yup.string(),
              value: yup.number(),
            } ).required(); // schema for object
          case 'string':
            return yup.string().required(); // schema for string
          default:
            return yup.mixed().notRequired(); // here you can decide what is the default
        }
      } ),
      city: yup.string().required(),
      street: yup.string().required(),
      houseNumber: yup.string().required(),
      phone: yup.string()
        .required( t( 'base:forms.messages.fieldRequired',
          { fieldLabel: t( 'bookingFunnel.personalData.phone' ) } ) )
        .matches( phoneValidationRegExp, t( 'bookingFunnel.personalData.phoneFormatErrorGM' ) ),
      email: yup.string().required( t( 'base:forms.messages.fieldRequired',
        { fieldLabel: t( 'bookingFunnel.personalData.email' ) } ) )
        .email( t( 'bookingFunnel.personalData.emailFormatErrorGM' ) ),
    } ).required();

    return formValidationSchema;
  }, [ t ] );
  return schema;
};

export const useSummaryValidationSchemaGM = (): yup.ObjectSchema<ISummaryStepGM> => {
  const schema = React.useMemo( () => {
    const formValidationSchema = yup.object<ISummaryStepGM>( {
      isAcceptedPrivacyPolicy: yup.boolean().oneOf( [ true ] ),
      isAcceptedTermsAndConditions: yup.boolean().oneOf( [ true ] ),
    } ).required();

    return formValidationSchema;
  }, [] );
  return schema;
};
